export const NotificationTypes = Object.freeze({
  NEW_RESERVATION: "NEW_RESERVATION",
  CONFIRM_RESERVATION: "CONFIRM_RESERVATION",
  CANCEL_RESERVATION: "CANCEL_RESERVATION",
  PAYMENT_FAILED_RESERVATION: "PAYMENT_FAILED_RESERVATION",
  PIX_PAYMENT_REVERSED: "PIX_PAYMENT_REVERSED",
  TRIP_CONFIRMATION: "TRIP_CONFIRMATION",
  CHAT: "CHAT"
});
